import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import {LicenseManager} from 'ag-grid-enterprise';


//LicenseManager.setLicenseKey('For_Trialing_ag-Grid_Only-Not_For_Real_Development_Or_Production_Projects-Valid_Until-24_October_2020_[v2]_MTYwMzQ5NDAwMDAwMA==ef5f6946fff5bf632125c41a235517db');

// LicenseManager.setLicenseKey('CompanyName=Channel Play,LicensedApplication=1ChannelCRM,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-016945,ExpiryDate=29_June_2022_[v2]_MTY1NjQ1NzIwMDAwMA==47e0c5fb0f631f9b58906d032f26c9ae');
LicenseManager.setLicenseKey('Using_this_{AG_Grid}_Enterprise_key_{AG-059955}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Channel_Play}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{1ChannelCRM}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{1ChannelCRM}_need_to_be_licensed___{1ChannelCRM}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{18_July_2025}____[v3]_[01]_MTc1Mjc5MzIwMDAwMA==8350b3f624f05030194f9b0570244ec6');
if (environment.production) {  
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
